import React from 'react';

export const MdTable = (props) => {
    const { className, cols, children } = props
    const columns = cols.split(',')
    const body = children.filter(item => !(/^\s*$/.test(item)))[0];
    const rows = body.props.children.filter(item => !(/^\s*$/.test(item)));
    return (
        <table className={className}>
            <thead>
                <tr>
                    {columns.map((column, index) => (
                        <th key={`th-${index}-${className}`}>{column}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, rowIndex) => {
                    const cells = row.props.children.filter(item => !(/^\s*$/.test(item)));
                    return (
                        <tr key={`tr-${rowIndex}-${className}`}>
                            {cells.map((cell, cellIndex) => {
                                // console.log(cell);
                                // return (<></>)
                                console.log(cell)
                                return (
                                    <td key={`td-${cellIndex}-${className}`}>{cell.props ? cell.props.children : ' '}</td>
                                )
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    );
};